import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_PACK,
    UPDATE_PACK,
    CREATE_PACK, DELETE_PACK
} from 'constants/packs.constants'
import axios from 'axios'
import {
    fetchPacksSuccess,
    updatePackSuccess,
    createPackSuccess,
    deletePackSuccess
} from "actions/packs.action";
import { showErrors, stopLoader } from "actions/general.action";


// pack sagas

const fetchPacksRequest = async (page) => {
    return axios.get('/api/v1/super_admin/packages');
}

function* fetchPacks({ payload }) {
    try {
        const reuslt = yield call(fetchPacksRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchPacksSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updatePacksRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = {id: payload.pack_type_id}
    o.country = {id: payload.country_id}

    return axios.put('/api/v1/super_admin/packages/' + payload.id,
        o
    );
}

function* updatePack({ payload }) {
    try {
        const reuslt = yield call(updatePacksRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updatePackSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createPacksRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = {id: payload.pack_type_id}
    o.country = {id: payload.country_id}

    return axios.post('/api/v1/super_admin/packages',
        o
    );
}

function* createPack({ payload }) {
    try {
        const reuslt = yield call(createPacksRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createPackSuccess(reuslt.data)),
                //put(stopLoader("Pack created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deletePacksRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/packages/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deletePack({ payload }) {
    try {
        const reuslt = yield call(deletePacksRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deletePackSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}


// fork pack
export function* forkFetchPacks() {
    yield takeEvery(FETCH_ALL_PACK, fetchPacks);
}

export function* forkUpdatePack() {
    yield takeEvery(UPDATE_PACK, updatePack);
}

export function* forkCreatePack() {
    yield takeEvery(CREATE_PACK, createPack);
}

export function* forkDeletePack() {
    yield takeEvery(DELETE_PACK, deletePack);
}


export default function* rootSaga() {
    yield all([
        fork(forkFetchPacks),
        fork(forkUpdatePack),
        fork(forkCreatePack),
        fork(forkDeletePack),
    ]);
}